// src/features/auth/hooks/useResetPassword.ts
import { useState } from 'react';

export const useResetPassword = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const resetPassword = async (email: string): Promise<boolean> => {
        setLoading(true);
        setError(null);

        await new Promise((r) => setTimeout(r, 1000)); // заглушка

        if (email === 'notfound@example.com') {
            setError('На сайте не найдено пользователя с таким email.');
            setLoading(false);
            return false;
        }

        // Успех
        setLoading(false);
        return true;
    };

    return { resetPassword, loading, error };
};
